export default __webpack_public_path__ + "static/media/229.c6927de6.jpg";